var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactDOM from "react-dom";
import * as React from "react";
import { TimePeriodPicker, TimePeriodPickerDefaultConfig } from "sb-resp-ui";
var TimePeriodPickerRoot = /** @class */ (function () {
    function TimePeriodPickerRoot(domId, config) {
        this.isActive = false;
        this.domId = domId;
        this.props = __assign({}, TimePeriodPickerDefaultConfig, config);
        this.activate();
    }
    TimePeriodPickerRoot.prototype.activate = function () {
        if (!this.isActive) {
            var domRef = document.getElementById(this.domId);
            if (domRef) {
                ReactDOM.render(React.createElement(TimePeriodPicker, __assign({}, this.props)), domRef);
                this.isActive = true;
            }
        }
        return this;
    };
    TimePeriodPickerRoot.prototype.deactivate = function () {
        var domRef = document.getElementById(this.domId);
        if (domRef) {
            ReactDOM.unmountComponentAtNode(domRef);
            this.isActive = false;
        }
        return this;
    };
    return TimePeriodPickerRoot;
}());
export { TimePeriodPickerRoot };
//In browser use: sbCommonLib.TimePeriodPickerRoot
//not this:
//window["TimePeriodPicker"] = TimePeriodPickerRoot;
//# sourceMappingURL=TimePeriodPicker.js.map